export default "__VITE_ASSET__D71tsUuW__"